<p-autoComplete
    [(ngModel)]="selected"
    [suggestions]="searchMenuResults"
    (completeMethod)="searchMenuItem($event)"
    *ngIf="isMenuSearchActive"
    (onSelect)="selectMenuItem($event)"
    field="name"
    placeholder="{{ 'Search... ' | localize }}"
    [minLength]="1"
    inputStyleClass="form-control menuSearchBarInput"
    styleClass="menuSearchBarContainer"
    class="search-menu"
></p-autoComplete>
<img src="../../../../../assets/common/images/search-icon.svg" class="search-icon" alt="">
